import {
  PROFILE_BASE_PATH,
  ProfileTabs,
  profileTabPath,
} from "~/v2/pages/dashboard/profile/profileTabs";
import { ADVANCED_TRADING_DASHBOARD_PATHS } from "~/v3-poc/pages/path";

export const Path = {
  ROUTE_PRO: ADVANCED_TRADING_DASHBOARD_PATHS.ROOT,
  ROUTE_PRO_LEGACY: "/next",
  ROUTE_V3_POC: "/v3-poc",

  // Authentication (/account/login)
  ROUTE_LOGIN: "/account/login",

  // OAuth (/oauth/*)
  ROUTE_AUTHX_AUTHORIZE: "/authorize",
  ROUTE_OAUTH_AUTHORIZE: "/oauth/authorize",

  // Dashboard (/dashboard/*)
  ROUTE_DASHBOARD: "/dashboard/overview",
  ROUTE_BALANCES: "/dashboard/balances",
  ROUTE_PROGRAM_INTEREST: "/dashboard/program-interest",

  // Account — holdings & activity (/account/*)
  ROUTE_POSITIONS: "/account/positions",
  ROUTE_ORDERS: "/account/orders",
  ROUTE_ORDER_DETAIL: "/dashboard/order/:orderId",
  ROUTE_ACCOUNT_ACTIVITIES: "/account/activities",

  // Account — settings & documents (/account/*)
  ROUTE_CONFIGURATION: "/account/configuration",
  ROUTE_DOCUMENTS: "/account/documents",
  ROUTE_PLANS_AND_FEATURES: "/account/plans-and-features",

  // User — profile & preferences (/user/*)
  ROUTE_PROFILE: PROFILE_BASE_PATH,
  ROUTE_PROFILE_BASIC_INFO: profileTabPath(ProfileTabs.BASIC_INFO),
  ROUTE_PROFILE_MANAGE_ACCOUNTS: profileTabPath(ProfileTabs.MANAGE_ACCOUNTS),
  ROUTE_PROFILE_DOCUMENT_REQUESTS: profileTabPath(
    ProfileTabs.DOCUMENT_REQUESTS,
  ),
  ROUTE_PROFILE_ADDITIONAL_INFO: profileTabPath(ProfileTabs.ADDITIONAL_INFO),
  ROUTE_PROFILE_TRUSTED_CONTACT: profileTabPath(ProfileTabs.TRUSTED_CONTACT),
  ROUTE_PROFILE_AGREEMENTS: profileTabPath(ProfileTabs.AGREEMENTS),
  ROUTE_PROFILE_SECURITY: profileTabPath(ProfileTabs.SECURITY),
  ROUTE_PROFILE_CONNECTED_APPS: profileTabPath(ProfileTabs.CONNECTED_APPS),
  ROUTE_PROFILE_CRYPTO_FEES: profileTabPath(ProfileTabs.CRYPTO_FEES),
  ROUTE_PROFILE_IP_ALLOWLIST: profileTabPath(ProfileTabs.IP_ALLOWLIST),
  ROUTE_ALPACA_TRADING_PLAN: "/user/trading-plan",

  // Compliance & tax (/sign/*)
  ROUTE_SIGN_W8BEN: "/sign/W8-BEN",

  // Trading (/trade/*)
  ROUTE_TRADE: "/trade/:symbol",
  ROUTE_TRADE_CRYPTO: "/trade/:base/:quote",

  // Alpaca Connect (/connect/*)
  ROUTE_ALPACA_CONNECT: "/connect",
  ROUTE_ALPACA_CONNECT_SUBMIT: "/connect/submit",
  ROUTE_ALPACA_CONNECT_EDIT: "/connect/edit/:clientId",
  ROUTE_ALPACA_CONNECT_APP: "/connect/:clientId",

  // Crypto transfers (/dashboard/crypto-transfers/*)
  ROUTE_CRYPTO_TRANSFERS: "/dashboard/crypto-transfers",
  ROUTE_CRYPTO_WHITELIST_ADDRESS:
    "/dashboard/crypto-transfers/whitelist-address",

  // Digital assets transfers (/dashboard/digital-assets-transfers/*)
  ROUTE_DIGITAL_ASSETS_TRANSFERS: "/dashboard/digital-assets-transfers",
  ROUTE_DIGITAL_ASSETS_WHITELIST_ADDRESS:
    "/dashboard/digital-assets-transfers/whitelist-address",

  // Market Data (/brokerage/market-data/*)
  ROUTE_MARKET_DATA: "/brokerage/market-data",
  ROUTE_MARKET_DATA_OVERVIEW: "/brokerage/market-data/overview",
  ROUTE_MARKET_DATA_SUBSCRIBE: "/brokerage/market-data/subscribe",
  ROUTE_MARKET_DATA_SELECT_PLAN: "/brokerage/market-data/subscribe/select-plan",
  ROUTE_MARKET_DATA_ELIGIBILITY_CHECK:
    "/brokerage/market-data/subscribe/eligibility-check",
  ROUTE_MARKET_DATA_ADDITIONAL_INFO:
    "/brokerage/market-data/subscribe/additional-info",
  ROUTE_MARKET_DATA_AGREEMENTS: "/brokerage/market-data/subscribe/agreements",
  ROUTE_MARKET_DATA_REVIEW: "/brokerage/market-data/subscribe/review",

  // Options opt-in (/brokerage/options/opt-in/*)
  ROUTE_OPTIONS_OPT_IN_FINANCIAL_PROFILE:
    "/brokerage/options/opt-in/financial-profile",
  ROUTE_OPTIONS_OPT_IN_INVESTMENT_EXPERIENCE:
    "/brokerage/options/opt-in/investment-experience",
  ROUTE_OPTIONS_OPT_IN_SPREADS: "/brokerage/options/opt-in/spreads",
  ROUTE_OPTIONS_OPT_IN_AGREEMENT: "/brokerage/options/opt-in/options-agreement",
  ROUTE_OPTIONS_OPT_IN_STATUS: "/brokerage/options/opt-in/status",
  ROUTE_OPTIONS_OPT_IN_ENTITY_ACCOUNT:
    "/brokerage/options/opt-in/entity-account",

  // Account onboarding — individual (/brokerage/new-account/*)
  ROUTE_NEW_ACCOUNT: "/brokerage/new-account",
  ROUTE_NEW_ACCOUNT_DYNAMIC_PAGE: "/brokerage/new-account/:page",

  // Account onboarding — entity (/brokerage/new-entity-account/*)
  ROUTE_ENTITY_ONBOARDING_BUSINESS_INFO:
    "/brokerage/new-entity-account/business-info",
  ROUTE_ENTITY_ONBOARDING_ACCOUNT_OPENER:
    "/brokerage/new-entity-account/account-opener",
  ROUTE_ENTITY_ONBOARDING_AUTH_INDIVIDUALS_UBOS:
    "/brokerage/new-entity-account/authorized-individuals-ubos",
  ROUTE_ENTITY_ONBOARDING_DOCUMENTS: "/brokerage/new-entity-account/documents",
  ROUTE_ENTITY_ONBOARDING_AGREEMENTS:
    "/brokerage/new-entity-account/agreements",
  ROUTE_ENTITY_ONBOARDING_COMPLETED: "/brokerage/new-entity-account/completed",

  // Account onboarding — IRA (/brokerage/new-ira-account/*)
  ROUTE_IRA_ONBOARDING: "/brokerage/new-ira-account",
  ROUTE_IRA_ONBOARDING_SELECT_TYPE: "/brokerage/new-ira-account/select-type",
  ROUTE_IRA_ONBOARDING_CONFIRM_INFORMATION:
    "/brokerage/new-ira-account/confirm-information",
  ROUTE_IRA_ONBOARDING_BENEFICIARIES:
    "/brokerage/new-ira-account/beneficiaries",
  ROUTE_IRA_ONBOARDING_STOCK_LENDING:
    "/brokerage/new-ira-account/stock-lending",
  ROUTE_IRA_ONBOARDING_AGREEMENTS: "/brokerage/new-ira-account/agreements",
  ROUTE_IRA_ONBOARDING_DYNAMIC_PAGE: "/brokerage/new-ira-account/:page",

  // Product enrollment — FPSL (/brokerage/fpsl-onboarding/*)
  ROUTE_FPSL_ONBOARDING: "/brokerage/fpsl-onboarding",
  ROUTE_FPSL_ONBOARDING_DYNAMIC_PAGE: "/brokerage/fpsl-onboarding/:page",
  ROUTE_FPSL_ONBOARDING_START: "/brokerage/fpsl-onboarding/start",
  ROUTE_FPSL_ONBOARDING_AGREEMENT: "/brokerage/fpsl-onboarding/agreement",

  // Product enrollment — high yield cash (/user/high-yield-cash/*)
  ROUTE_HIGH_YIELD_ENROLL: "/user/high-yield-cash/enroll",
  ROUTE_HIGH_YIELD_ENROLL_AGREEMENT: "/user/high-yield-cash/enroll-agreement",
  ROUTE_HIGH_YIELD_ENROLL_COMPLETED: "/user/high-yield-cash/enroll-completed",

  // Funding (/brokerage/funding/*)
  ROUTE_FUNDING: "/brokerage/funding",
  ROUTE_FUNDING_HISTORY: "/brokerage/funding/history",
  ROUTE_FUNDING_LINK_ACH: "/brokerage/funding/link/ach",
  // Plaid OAuth full-page-redirect return page. This value MUST exactly match the
  // Plaid-registered redirect_uri (gobroker PLAID_REDIRECT_URI). We reuse the
  // legacy native path so no infra repoint or Plaid Dashboard change is needed —
  // Plaid redirects here with ?oauth_state_id=... and receivedRedirectUri matches.
  ROUTE_FUNDING_LINK_ACH_OAUTH: "/mobile/plaid/oauth-page.html",
  ROUTE_FUNDING_LINK_WIRE: "/brokerage/funding/link/wire",
  ROUTE_FUNDING_LINK_CURRENCYCLOUD: "/brokerage/funding/link/currencycloud",
  ROUTE_FUNDING_DEPOSIT: "/brokerage/funding/deposit",
  ROUTE_FUNDING_DEPOSIT_ACH: "/brokerage/funding/deposit/ach",
  ROUTE_FUNDING_DEPOSIT_WIRE: "/brokerage/funding/deposit/wire",
  ROUTE_FUNDING_DEPOSIT_CURRENCYCLOUD:
    "/brokerage/funding/deposit/currencycloud",
  ROUTE_FUNDING_WITHDRAW: "/brokerage/funding/withdraw",
  ROUTE_FUNDING_WITHDRAW_ACH: "/brokerage/funding/withdraw/ach",
  ROUTE_FUNDING_WITHDRAW_WIRE: "/brokerage/funding/withdraw/wire",
  ROUTE_FUNDING_WITHDRAW_CURRENCYCLOUD:
    "/brokerage/funding/withdraw/currencycloud",

  // Portfolio transfer / ACATS (/brokerage/portfolio-transfer/*)
  ROUTE_PORTFOLIO_TRANSFER: "/brokerage/portfolio-transfer",
  ROUTE_PORTFOLIO_TRANSFER_ORIGINATING_BROKER:
    "/brokerage/portfolio-transfer/originating-broker",
  ROUTE_PORTFOLIO_TRANSFER_ACCOUNT_INFO:
    "/brokerage/portfolio-transfer/account-information",
  ROUTE_PORTFOLIO_TRANSFER_ASSETS_HOLDING:
    "/brokerage/portfolio-transfer/assets-holding",
  ROUTE_PORTFOLIO_TRANSFER_PARTIAL_TRANSFER:
    "/brokerage/portfolio-transfer/partial-transfer",
  ROUTE_PORTFOLIO_TRANSFER_REVIEW: "/brokerage/portfolio-transfer/review",

  // External URLs
  URL_BUG_REPORT: "https://forms.gle/32B6T3bbWzL6agbC7",
  URL_DOCS: "https://docs.alpaca.markets/docs",
  URL_DOCS_ACCOUNT_ACTIVITIES:
    "https://docs.alpaca.markets/docs/account-activities",
  URL_SLACK: "https://alpaca.markets/slack",
  URL_FORUM: "https://forum.alpaca.markets",
  URL_SUPPORT: "https://alpaca.markets/support",
  URL_DISCLOSURES: "https://alpaca.markets/disclosures",

  // Helpers
  format: (path: string, params: { [key: string]: string }) =>
    Object.keys(params).reduce(
      (acc, key) =>
        acc.replace(`:${key}`, params[key].replace("live", "brokerage")),
      path,
    ),
};

export const Redirects: Record<string, string> = {
  [Path.ROUTE_PRO_LEGACY]: Path.ROUTE_PRO,
  [Path.ROUTE_V3_POC]: Path.ROUTE_PRO,
  "/login": Path.ROUTE_LOGIN,
  "/new-account": Path.ROUTE_NEW_ACCOUNT,
  "/positions": Path.ROUTE_POSITIONS,
  "/orders": Path.ROUTE_ORDERS,
  "/brokerage/document-requests": Path.ROUTE_PROFILE_DOCUMENT_REQUESTS,
};

export const ONBOARDING_PATHS = [
  Path.ROUTE_NEW_ACCOUNT,
  Path.ROUTE_ENTITY_ONBOARDING_BUSINESS_INFO,
  Path.ROUTE_ENTITY_ONBOARDING_ACCOUNT_OPENER,
  Path.ROUTE_ENTITY_ONBOARDING_AUTH_INDIVIDUALS_UBOS,
  Path.ROUTE_ENTITY_ONBOARDING_DOCUMENTS,
  Path.ROUTE_ENTITY_ONBOARDING_AGREEMENTS,
  Path.ROUTE_ENTITY_ONBOARDING_COMPLETED,
];

export const BANKING_PATHS = [
  Path.ROUTE_FUNDING,
  Path.ROUTE_FUNDING_HISTORY,
  Path.ROUTE_FUNDING_LINK_ACH,
  Path.ROUTE_FUNDING_LINK_ACH_OAUTH,
  Path.ROUTE_FUNDING_LINK_WIRE,
  Path.ROUTE_FUNDING_LINK_CURRENCYCLOUD,
  Path.ROUTE_FUNDING_DEPOSIT,
  Path.ROUTE_FUNDING_DEPOSIT_ACH,
  Path.ROUTE_FUNDING_DEPOSIT_WIRE,
  Path.ROUTE_FUNDING_DEPOSIT_CURRENCYCLOUD,
  Path.ROUTE_FUNDING_WITHDRAW,
  Path.ROUTE_FUNDING_WITHDRAW_ACH,
  Path.ROUTE_FUNDING_WITHDRAW_WIRE,
  Path.ROUTE_FUNDING_WITHDRAW_CURRENCYCLOUD,
];
